import { ISwitchOption } from "components/inputs/Switch"
import { createAction } from "@reduxjs/toolkit"
import { ScheduleDayOfWeekType } from "model/food/types/schedule.types"
import { getDefaultBodyDisplayUnit } from "utils/localeDetector"

export const SUPPORT_REQUEST_URL =
  "https://help.zozofit.com/hc/en-us/requests/new"
export const HELP_CENTER_URL = "https://help.zozofit.com/hc/en-us"

export const REMAINING_SCAN_TIMES_MESSAGE_AFFIX =
  "Make sure to come back tomorrow for more!"

export const resetStoreAction = createAction("RESET_STORE")

export const GOAL_NOT_FOUND = "Goal not found"

export const CALORIES_FILL_COLOR = "#0FBDD4"
export const FILL_COLOR_OVER = "#FF4921"
export const TRACK_COLOR = "rgba(0, 38, 58, 0.14)"
export const TRACK_COLOR_OVER = "#FFC800"

export const PACKAGE_TYPE = "PACKAGE"

export const GOAL_WORDING = {
  WEIGHT_LOSS:
    "Losing weight means balancing calories, protein, fat, and carbs to create a calorie deficit while nourishing your body.\nCutting calories helps burn fat, while protein preserves muscle and keeps your metabolism active. Healthy fats keep you fuller longer and support nutrient absorption.\nCarbs provide energy for workouts and daily activities, helping you stay active. Together, these nutrients support weight loss, muscle maintenance, and overall well-being.",
  MAINTAIN:
    "Keeping your weight steady is all about balancing key nutrients: calories, protein, fat, and carbs.\nCalories power you through your day, protein keeps your muscles strong, fats support hormone health, and carbs keep your brain and body fueled.\nBy consuming the right amounts of these nutrients, you can maintain a stable weight, stay energized, and support your overall health.",
  BUILDING:
    "Gaining weight in a healthy way requires an increase in calories, protein, fat, and carbs to support growth and energy.\nCalories fuel mass building, protein aids muscle growth, fats provide energy and support hormone balance, while carbs boost stamina and muscle development. These nutrients work together for balanced, sustainable weight gain.",
  NOT_SURE:
    "Keeping your weight steady is all about balancing key nutrients: calories, protein, fat, and carbs.\nCalories power you through your day, protein keeps your muscles strong, fats support hormone health, and carbs keep your brain and body fueled.\nBy consuming the right amounts of these nutrients, you can maintain a stable weight, stay energized, and support your overall health.",
}

export const DATE_PARAM_FORMAT = "YYYY-MM-DD"
export const US_DATE_FORMAT = "MM/DD/YYYY"
export const US_DATE_FORMAT_WITHOUT_YEAR = "MMM DD"
export const US_DATE_FORMAT_WITH_YEAR = "MMM DD, YYYY"
export const US_DATE_FORMAT_SHORT = "MM/DD/YY"
export const MONTH_DAY_FORMAT = "MMM D"
export const DAY_YEAR_FORMAT = "D, YYYY"
export const MONTH_DAY_YEAR_FORMAT = "MMM D, YYYY"

export const MAINTAIN_WEIGHT_TYPES = ["MAINTAIN", "NOT_SURE"]

export const FOOD_DETAILS_BODY_ID = "food-details-body"
export const NUTRITION_FACTS_FOOD_TYPE = "NUTRITION_FACTS"

export const FIRST_REMAINING_LOG_MEAL_TIME_TO_SHOW_PAYWALL = 2
export const REMAINING_LOG_MEAL_TIME_TO_SHOW_PAYWALL = 4

export const APP_DEFAULT_DECIMAL_PLACE = 2
export const MEAL_MACRO_DECIMAL_PLACE = 1
export const CALORIES_DECIMAL_PLACE = 0
export const WATER_OZ_DECIMAL_PLACE = 1
export const PORTION_DECIMAL_PLACE = 2

export const BODY_INPUT_DECIMAL_PLACE = 1
export const BODY_SMALLEST_UNIT_DECIMAL_PLACE = 0

export const DEFAULT_BODY_DISPLAY_UNIT = getDefaultBodyDisplayUnit()

export const bodyDisplayUnitsOptions: [ISwitchOption, ISwitchOption] = [
  { label: "Imperial", value: "IMPERIAL" },
  {
    label: "Metric",
    value: "METRIC",
  },
]

export const DAYS_OF_WEEK: ScheduleDayOfWeekType[] = [
  "SUNDAY",
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
]

export const DEFAULT_SUGGESTED_MEALS_PAGE_SIZE = 20
export const DEFAULT_RECENT_INGREDIENTS_PAGE_SIZE = 20

export const ENTITLEMENT_IDS = {
  NO_ADS: "NO_ADS",
  BOOTY_ASSESSMENT: "BOOTY_ASSESSMENT",
  BODY_STATS: "BODY_STATS",
  WEEKLY_RECAP: "WEEKLY_RECAP",
  AI_FOOD_SCANNING: "AI_FOOD_SCANNING",
  BARCODE_SCANNING: "BARCODE_SCANNING",
}

export const PLAN_TYPES = {
  FREE: "FREE",
  PREMIUM: "PREMIUM",
}

export const SCAN_MESSAGE_NO_SCAN = "You haven't completed a body scan."
export const SCAN_MESSAGE_STALE_SCAN =
  "Your scan was more than 2 weeks ago.\nRe-scan for the most accurate data."
export const SCAN_MESSAGE_WEIGHT_CHANGED =
  "Looks like your weight has changed from your last scan!"
